'use client';

import { c as _c } from "react/compiler-runtime";
import { useT } from '@repo/i18n/components/i18n.client';
import { css } from '@repo/panda/css';
import * as MapLibre from 'maplibre-gl';
import { useCallback, useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { useMapContext } from '../game-map/map-context';
import { PlayerLocationMarkerGraphic } from '../player-location-marker/player-location-marker-graphic';
const MOCK_FACING_BEARING = -30;
interface LiveLocationCtaMarkerProps {
  onOpen: () => void;
  onHover: () => void;
}
export function LiveLocationCtaMarker(t0) {
  const $ = _c(14);
  const {
    onOpen,
    onHover
  } = t0;
  const {
    map
  } = useMapContext();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["game_map"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useT(t1);
  const markerRef = useRef(null);
  const [portalTarget, setPortalTarget] = useState(null);
  let t2;
  if ($[1] !== map) {
    t2 = () => {
      if (!map || !markerRef.current) {
        return;
      }
      const canvas = map.getCanvas();
      const point = [canvas.clientWidth * 0.44, canvas.clientHeight * 0.61];
      markerRef.current.setLngLat(map.unproject(point));
    };
    $[1] = map;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const updateMarkerPosition = t2;
  let t3;
  let t4;
  if ($[3] !== map || $[4] !== updateMarkerPosition) {
    t3 = () => {
      if (!map) {
        return;
      }
      const target = document.createElement("div");
      target.style.pointerEvents = "none";
      setPortalTarget(target);
      markerRef.current = new MapLibre.Marker({
        element: target,
        anchor: "center"
      }).setLngLat(map.getCenter()).addTo(map);
      const frame = window.requestAnimationFrame(updateMarkerPosition);
      map.once("idle", updateMarkerPosition);
      map.on("resize", updateMarkerPosition);
      return () => {
        window.cancelAnimationFrame(frame);
        map.off("idle", updateMarkerPosition);
        map.off("resize", updateMarkerPosition);
        markerRef.current?.remove();
        markerRef.current = null;
        setPortalTarget(null);
      };
    };
    t4 = [map, updateMarkerPosition];
    $[3] = map;
    $[4] = updateMarkerPosition;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  useEffect(t3, t4);
  let t5;
  if ($[7] !== onHover || $[8] !== onOpen || $[9] !== portalTarget || $[10] !== t) {
    t5 = portalTarget && ReactDOM.createPortal(<div className={css({
      position: "relative",
      display: "grid",
      placeItems: "center"
    })}><PlayerLocationMarkerGraphic bearing={MOCK_FACING_BEARING} /><button type="button" aria-label={t(_temp)} onPointerDown={_temp2} onPointerUp={_temp3} onClick={event_1 => {
        event_1.stopPropagation();
        onOpen();
      }} onMouseEnter={event_2 => {
        event_2.stopPropagation();
        onHover();
      }} className={css({
        position: "absolute",
        top: "[50%]",
        left: "[50%]",
        transform: "[translate(-50%, -50%)]",
        width: "[64px]",
        height: "[64px]",
        borderWidth: "0",
        borderRadius: "full",
        background: "transparent",
        cursor: "pointer",
        pointerEvents: "auto",
        _focusVisible: {
          outline: "[2px solid token(colors.brand.primary)]",
          outlineOffset: "2"
        }
      })} /></div>, portalTarget);
    $[7] = onHover;
    $[8] = onOpen;
    $[9] = portalTarget;
    $[10] = t;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t5) {
    t6 = <>{t5}</>;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}
function _temp3(event_0) {
  return event_0.stopPropagation();
}
function _temp2(event) {
  return event.stopPropagation();
}
function _temp($) {
  return $.live_location_cta.marker_aria_label;
}